import { Box, Typography, Paper, Stack } from "@mui/material";
import DomainIcon from "@mui/icons-material/Language";
import TrademarkIcon from "@mui/icons-material/Verified";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import EditIcon from "@mui/icons-material/Edit";
import ScienceIcon from "@mui/icons-material/Science";
import { styles as localStyles } from "./TutorialContent.styles";

const TutorialCard = ({ number, title, children, sx, styles }) => (
  <Paper elevation={0} sx={{ ...styles.tutorialCard, ...sx }}>
    <Box sx={styles.tutorialCardNumber}>
      <Box sx={styles.tutorialCardNumberCircle}>{number}</Box>
    </Box>
    <Box sx={styles.tutorialCardHeader}>{title}</Box>
    <Box sx={styles.tutorialCardContent}>{children}</Box>
  </Paper>
);

const InfoField = ({ label, value, styles }) => (
  <Box sx={styles.infoField}>
    <Typography variant="subtitle2" sx={styles.infoFieldLabel}>
      {label}
    </Typography>
    <Box sx={styles.infoFieldValue}>{value}</Box>
  </Box>
);

const WorkflowDiagram = ({ customStyles }) => {
  const styles = { ...localStyles, ...customStyles };

  return (
    <Box sx={styles.workflowContainer}>
      <Typography variant="h5" sx={styles.workflowTitle}>
        AI Brand Name Generation and Analysis Steps
      </Typography>
      <Box sx={styles.workflowCardsContainer}>
        <TutorialCard number={1} title="Select Report Type" styles={styles}>
          <Stack spacing={2} sx={{ width: "100%", flexGrow: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <EditIcon sx={styles.workflowIcon} />
              <Typography variant="subtitle1" sx={styles.workflowTitleText}>
                Name Ideation
              </Typography>
            </Box>
            <Typography variant="body2" sx={styles.workflowDescription}>
              Generate name candidates.
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TrademarkIcon sx={styles.workflowIcon} />
              <Typography variant="subtitle1" sx={styles.workflowTitleText}>
                Trademark
              </Typography>
            </Box>
            <Typography variant="body2" sx={styles.workflowDescription}>
              Generate trademark name conflict analysis.
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <DomainIcon sx={styles.workflowIcon} />
              <Typography variant="subtitle1" sx={styles.workflowTitleText}>
                Domain
              </Typography>
            </Box>
            <Typography variant="body2" sx={styles.workflowDescription}>
              Match your name candidates with available domains and score them.
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <ScienceIcon sx={styles.workflowIcon} />
              <Typography
                variant="subtitle1"
                sx={{ ...styles.workflowTitleText, ml: 1 }}
              >
                Full Research
              </Typography>
            </Box>
            <Typography variant="body2" sx={styles.workflowDescription}>
              Generate new names, check for trademark name conflicts, and find
              domain name matches.
            </Typography>
          </Stack>
        </TutorialCard>
        <TutorialCard number={2} title="Describe Your Brand" styles={styles}>
          <InfoField
            label="Project Description*"
            value="We create innovative space-themed night lamps that transform bedrooms into cosmic sanctuaries..."
            styles={styles}
          />
          <InfoField
            label="Industry"
            value="Home decor and lighting industry, focusing on educational and decorative.."
            styles={styles}
          />
          <InfoField
            label="Candidate Names*"
            value="Celestial Shine, Astral Ambiance"
            styles={styles}
          />
        </TutorialCard>
        <TutorialCard
          number={3}
          title="View Results and Iterate"
          styles={styles}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box sx={styles.submitButton}>Click Submit</Box>
            <AutorenewIcon sx={styles.iterateIcon} />
            <Typography variant="subtitle1" sx={styles.iterateTitle}>
              Iterate, Refine, and Discover Your Best Name!
            </Typography>
            <Typography variant="body2" sx={styles.iterateDescription}>
              Review your results, try new ideas, and keep improving until you
              find the perfect fit.
            </Typography>
          </Box>
        </TutorialCard>
      </Box>
      <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      `}</style>
    </Box>
  );
};

export default WorkflowDiagram;
